/*
 * Action Types
 */
export enum CompanyUsersTypes {
  CHECK_COMPANY_USERS_REQUEST = '@companyUsers/CHECK_COMPANY_USERS_REQUEST',
  CHECK_COMPANY_USERS_SUCCESS = '@companyUsers/CHECK_COMPANY_USERS_SUCCESS',
  CHECK_COMPANY_USERS_FAILURE = '@companyUsers/CHECK_COMPANY_USERS_FAILURE',

  CHARGE_REQUEST_EXTERNAL_REQUEST = '@companyUsers/CHARGE_REQUEST_EXTERNAL_REQUEST',
  CHARGE_REQUEST_EXTERNAL_SUCCESS = '@companyUsers/CHARGE_REQUEST_EXTERNAL_SUCCESS',
  CHARGE_REQUEST_EXTERNAL_FAILURE = '@companyUsers/CHARGE_REQUEST_EXTERNAL_FAILURE',

  LIST_COMPANY_USERS_REQUEST = '@companyUsers/LIST_COMPANY_USERS_REQUEST',
  LIST_COMPANY_USERS_SUCCESS = '@companyUsers/LIST_COMPANY_USERS_SUCCESS',
  LIST_COMPANY_USERS_FAILURE = '@companyUsers/LIST_COMPANY_USERS_FAILURE',

  CREATE_COMPANY_USERS_REQUEST = '@companyUsers/CREATE_COMPANY_USERS_REQUEST',
  CREATE_COMPANY_USERS_SUCCESS = '@companyUsers/CREATE_COMPANY_USERS_SUCCESS',
  CREATE_COMPANY_USERS_FAILURE = '@companyUsers/CREATE_COMPANY_USERS_FAILURE',

  UPDATE_COMPANY_USERS_REQUEST = '@companyUsers/UPDATE_COMPANY_USERS_REQUEST',
  UPDATE_COMPANY_USERS_SUCCESS = '@companyUsers/UPDATE_COMPANY_USERS_SUCCESS',
  UPDATE_COMPANY_USERS_FAILURE = '@companyUsers/UPDATE_COMPANY_USERS_FAILURE',

  DELETE_COMPANY_USERS_REQUEST = '@companyUsers/DELETE_COMPANY_USERS_REQUEST',
  DELETE_COMPANY_USERS_SUCCESS = '@companyUsers/DELETE_COMPANY_USERS_SUCCESS',
  DELETE_COMPANY_USERS_FAILURE = '@companyUsers/DELETE_COMPANY_USERS_FAILURE',

  DELETE_COMPANY_USER_REQUEST = '@companyUsers/DELETE_COMPANY_USER_REQUEST',
  DELETE_COMPANY_USER_SUCCESS = '@companyUsers/DELETE_COMPANY_USER_SUCCESS',
  DELETE_COMPANY_USER_FAILURE = '@companyUsers/DELETE_COMPANY_USER_FAILURE',
}

/*
 * Data types
 */
export interface CompanyUsersInterface {
  name: string;
  document: string;
  value?: string;
}

/*
 * State type
 */
export interface CompanyUsersState {
  readonly companyUsersList: CompanyUsersInterface[];
  readonly companyUsersData: CompanyUsersInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
  readonly checkCompanyUsersList: CompanyUsersInterface[];
}
